import React from 'react';
import AdminAccount from '../components/AdminAccount';

const AdminAccountPage: React.FC = () => <AdminAccount />;

export default AdminAccountPage;
